<template>
  <div class="page page--login">
    <div class="login">
      <template v-if="isResetActive">
        <h1 class="title login__title">Wachtwoord reset</h1>
        <template v-if="isResetSuccess">
          <p class="success">Aanvraag verstuurd check uw mailbox.</p>
          <p class="login__forgotten" @click="returnLogin">Terug naar login</p>
        </template>
        <template v-else>
          <label for="userreset">{{$t('login.username')}}</label>
          <input class="input login__input input--login" id="userreset" type="text"
                 :name="Math.round(Math.random() * Date.now())"
                 v-model="resetname" :placeholder="$t('login.username')" autocomplete="new-password"/>
          <button class="button button--cancel" type="button" @click="returnLogin">Annuleer</button>
          <button class="button" type="button"
                  @click="submitReset">Stuur aanvraag
          </button>
          <div class="error login__error"><span v-if="isResetError">Er is iets foutgelopen bij het versturen van uw aanvraag.</span>
          </div>
        </template>
      </template>
      <template v-else>
        <h1 class="title login__title">{{$t('login.title')}}</h1>
        <label for="user">{{$t('login.username')}}</label>
        <input class="input login__input input--login" id="user" type="text" :name="Math.round(Math.random() * Date.now())"
               v-model="username" :placeholder="$t('login.username')" autocomplete="new-password"/>
        <label for="pass">{{$t('login.password')}}</label>
        <input class="input login__input input--login" id="pass" type="password"
               :name="Math.round(Math.random() * Date.now())"
               v-model="password" @keypress.enter="submitLogin" :placeholder="$t('login.password')"
               autocomplete="password"/>
        <button class="button" :class="{'button--disabled':authenticating||!loginActive}"
                type="button"
                @click="submitLogin">{{$t('login.submit')}}
        </button>
        <div class="login__forgotten" @click="isResetActive=true">Wachtwoord vergeten?</div>
        <div class="error login__error"><span v-if="authenticationError">{{authenticationError}}</span></div>
      </template>

    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import UserService from "@/services/user";

export default {
  name: "Login",

  data() {
    return {
      username: "",
      password: "",

      errorVisible: false,
      errorMessage: "",

      resetname: "",
      isResetActive: false,
      isResetError: false,
      isResetSuccess: false
    };
  },

  computed: {
    ...mapGetters('auth', [
      'authenticating',
      'authenticationError',
      'authenticationErrorCode'
    ]),

    loginActive() {
      return this.username !== '' && this.password !== '';
    }
  },

  created() {
    this.resetAuthState();
  },


  methods: {

    ...mapActions('auth', [
      'loginReset',
      'login'
    ]),


    resetAuthState(){
      this.loginReset();
    },

    submitLogin() {
      if (this.username !== '' && this.password !== '') {
        this.login({username: this.username, password: this.password});
        this.password = "";
      }
    },

    submitReset() {
      if (this.resetname) {
        UserService.resetPassword(this.resetname)
          .then(res => {
            if (res.status) {
              this.isResetSuccess = true;
              return;
            }
            this.isResetError = true;
          });

      } else {
        this.isResetError = true;
      }
    },

    returnLogin() {
      this.isResetSuccess = false;
      this.isResetError = false;
      this.isResetActive = false;
      this.resetname = "";
    }
  }
}
</script>
